// IntersectionObserver has native support in all evergreen browsers
// (Chrome 51+, Safari 12.1+, Firefox 55+). Gatsby 5 dropped IE11 support,
// so the polyfill is dead weight (~5 KB min+gz).
import './src/stylesheets/main.scss'

// Segment analytics stub so early callers don't explode before the real
// snippet loads. Replaced once the production loader below runs.
export const onClientEntry = () => {
  if (typeof window !== 'undefined' && !window.analytics) {
    const noop = () => {}
    window.analytics = {
      page: noop,
      track: noop,
      identify: noop,
      group: noop,
      alias: noop,
      reset: noop,
      ready: noop,
      debug: noop,
      on: noop,
      once: noop,
      off: noop,
    }
  }
}

// Defer third-party analytics (Segment + GTM) until the browser is idle.
// Previously these were emitted inline in src/html.js, which forced the
// parser to evaluate them during initial load and hurt LCP/TBT. Running
// them from onInitialClientRender with requestIdleCallback keeps them out
// of the critical path while still firing before any user interaction.
const loadSegment = () => {
  if (window.__lpSegmentLoaded) return
  window.__lpSegmentLoaded = true
  /* eslint-disable */
  !(function () {
    var analytics = (window.analytics = window.analytics || [])
    if (!analytics.initialize) {
      if (analytics.invoked) {
        window.console && console.error && console.error('Segment snippet included twice.')
      } else {
        analytics.invoked = !0
        analytics.methods = [
          'trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview',
          'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug',
          'page', 'once', 'off', 'on',
        ]
        analytics.factory = function (t) {
          return function () {
            var e = Array.prototype.slice.call(arguments)
            e.unshift(t)
            analytics.push(e)
            return analytics
          }
        }
        for (var t = 0; t < analytics.methods.length; t++) {
          var e = analytics.methods[t]
          analytics[e] = analytics.factory(e)
        }
        analytics.load = function (t, e) {
          var n = document.createElement('script')
          n.type = 'text/javascript'
          n.async = !0
          n.src = 'https://cdn.segment.com/analytics.js/v1/' + t + '/analytics.min.js'
          var a = document.getElementsByTagName('script')[0]
          a.parentNode.insertBefore(n, a)
          analytics._loadOptions = e
        }
        analytics.SNIPPET_VERSION = '4.1.0'
        analytics.load('wImS7NMTnfYEayYHDOZyLhKl6ET9WpAd')
      }
    }
  })()
  /* eslint-enable */
}

const loadGTM = () => {
  if (window.__lpGtmLoaded) return
  window.__lpGtmLoaded = true
  /* eslint-disable */
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var f = d.getElementsByTagName(s)[0]
    var j = d.createElement(s)
    var dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', 'GTM-NJ55H87')
  /* eslint-enable */
}

const scheduleIdle = (fn, timeout) => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(fn, { timeout })
  } else {
    window.setTimeout(fn, timeout)
  }
}

export const onInitialClientRender = () => {
  if (process.env.NODE_ENV !== 'production') return
  if (typeof window === 'undefined') return
  scheduleIdle(loadSegment, 2500)
  scheduleIdle(loadGTM, 3500)
}
